/** Decode once, preserving HTTP refusals even when a gateway responds with HTML. */
export async function readApiResponse<T>(response: Response): Promise<T> {
  let payload: unknown;
  try { payload = await response.json(); }
  catch (error) {
    if (error instanceof Error && error.name === 'AbortError') throw error;
    if (response.ok) throw Object.assign(new Error('Сервер вернул некорректный ответ. Повторите попытку.'), { code: 'INVALID_RESPONSE', status: response.status });
  }
  if (!response.ok) {
    const body = payload && typeof payload === 'object' ? (payload as { error?: { code?: unknown; message?: unknown } }).error : undefined;
    throw Object.assign(new Error(typeof body?.message === 'string' ? body.message : 'Не удалось выполнить запрос. Повторите попытку.'), {
      code: typeof body?.code === 'string' ? body.code : undefined, status: response.status,
    });
  }
  return payload as T;
}
